import { render, staticRenderFns } from "./GeorchestraHeader.vue?vue&type=template&id=4da9dd81"
import script from "./GeorchestraHeader.vue?vue&type=script&lang=js"
export * from "./GeorchestraHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports